module.exports = vendor_b82688a471b737ceddd1;